import React, {memo, useCallback, useMemo, useState} from 'react';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {useSelector} from 'react-redux';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ControlTypeModel} from '../../../../types/control';
import {DEVELOPER_URL} from '../../index';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: ControlTypeModel) => item.id;

export const ControlTypeListScreen = memo(function ControlTypeListScreen() {
    const {t} = useLocalization()
    const controlTypeList = useSelector(state => state.control.controlTypeList);

    const [selectedControlType, setSelectedControlType] = useState<ControlTypeModel<unknown>>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/developer/control-type/edit/${selectedControlType ? selectedControlType.id : ''}`,
            className: 'orange',
            hidden: !(selectedControlType),
        },
        // {
        //     text: 'Kontrol Tip OLUŞTUR',
        //     url: '/developer/control-type/edit',
        //     className: 'green',
        // },
    ], [t, selectedControlType]);

    const displayNameExtractor = useCallback((item: ControlTypeModel, column: ColumnModel) => {
        if (column.key === 'bridge_device_type_count') {
            return item.allowed_bridge_device_type_id_list.length.toString();
        }

        if (column.key === 'show_on_homepage') {
            return item.show_on_homepage ? t('yes') : t('no');
        }

        return item[column.key] || '-';
    }, [t]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('control_type_name'),
            key: 'name',
        },
        {
            length: 2,
            name: t('render_type'),
            key: 'render_type',
        },
        {
            length: 2,
            name: t('see_on_homepage'),
            key: 'show_on_homepage',
        },
        {
            length: 2,
            name: t('control_count'),
            key: 'bridge_device_type_count',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole='developer' isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className="camera-list-page"
                backUrl={DEVELOPER_URL}>
                <SettingsList
                    columns={columns}
                    items={controlTypeList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedControlType}
                    onItemSelected={setSelectedControlType}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
